import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTermination } from '../api/terminations.js';
import { useToast } from '../contexts/ToastContext';
import DocForm from './DocForm.jsx';

export default function CreateTerminationModal({ contractId, onClose }) {
  const qc = useQueryClient();
  const { addToast } = useToast();
  const [initiator, setInitiator] = useState('company');
  const [documentDate, setDocumentDate] = useState(new Date().toISOString().slice(0, 10));

  const mutation = useMutation({
    mutationFn: () => createTermination(contractId, { initiator, documentDate }),
    onSuccess: () => {
      addToast('Готово', 'Расторжение создано', 'success');
      qc.invalidateQueries({ queryKey: ['terminations', contractId] });
      onClose();
    },
    onError: () => addToast('Ошибка', 'Не удалось создать расторжение', 'error'),
  });

  return (
    <DocForm
      title="Расторжение договора"
      onClose={onClose}
      closeDisabled={mutation.isPending}
      actions={(
        <>
          <button
            type="button"
            className="documents-action-btn"
            onClick={onClose}
            disabled={mutation.isPending}
          >
            Отмена
          </button>
          <button
            type="button"
            className="documents-action-btn documents-action-btn--primary"
            onClick={() => mutation.mutate()}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? 'Создание…' : 'Создать'}
          </button>
        </>
      )}
    >
      <div className="doc-form__grid">
        <div className="contract-inline-form__field doc-form__span2">
          <label>Инициатор</label>
          <div className="doc-form__radios doc-form__radios--row">
            <label>
              <input
                type="radio"
                name={`initiator-${contractId}`}
                value="company"
                checked={initiator === 'company'}
                onChange={() => setInitiator('company')}
              />
              По нашей инициативе
            </label>
            <label>
              <input
                type="radio"
                name={`initiator-${contractId}`}
                value="blogger"
                checked={initiator === 'blogger'}
                onChange={() => setInitiator('blogger')}
              />
              По инициативе блогера
            </label>
          </div>
        </div>

        <div className="contract-inline-form__field">
          <label htmlFor={`termination-date-${contractId}`}>Дата документа</label>
          <input
            id={`termination-date-${contractId}`}
            type="date"
            value={documentDate}
            onChange={(e) => setDocumentDate(e.target.value)}
          />
        </div>
      </div>
    </DocForm>
  );
}
